export function getAlbumName({
  albumId,
}: {
  albumId?: string;
}): string | undefined {
  if (!albumId) return undefined;

  const map: { [key: string]: string } = {
    FWC_2022: "Copa do Mundo Masculina FIFA 2022",
    FWWC_2023: "Copa do Mundo Feminina FIFA 2023",
  };

  return map[albumId];
}
